import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKycFormOpen } from "@features/KnowYourCustomerNotification/utils";
import { ClassicLoader } from "@components/ClassicLoader/ClassicLoader";
import { useModalActions } from "@store/modal/modal";
import { useKnowYourCustomerOverviewQuery } from "@services/knowYourCustomer/queries";

export const AppKYCInitiator: React.FC = () => {
  const { create, close } = useModalActions();
  const navigate = useNavigate();

  const { data: knowYourCustomerOverview, isLoading } =
    useKnowYourCustomerOverviewQuery();

  const { open } = useKycFormOpen();

  useEffect(() => {
    let id: number | undefined;

    const handleModal = async () => {
      if (isLoading) {
        return;
      }

      id = await open({
        onPause: () => {
          navigate("/status/pause");
        },
      });
    };

    void handleModal();

    return () => {
      if (id) {
        close(id);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [create, close, knowYourCustomerOverview, isLoading]);

  return (
    <div className="flex h-dvh w-full items-center justify-center">
      <ClassicLoader />
    </div>
  );
};
